import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { capitalize, getCreditCardIcon } from "helpers/Helpers";
import { ICreditCard } from "pages/guest/Customer/CustomerProfile";
import "./creditCardItem.scss";
import Checkbox from "components/form/checkbox/Checkbox";
import { ButtonNew as Button } from "components/buttonNew";

interface ICreditCardItemProps {
  creditCard: ICreditCard;
  isSelected?: boolean;
  onClick?: (creditCard: ICreditCard) => void;
  showCheckbox?: boolean;
  alignTop?: boolean;
  moreOptions?: boolean;
}

export function CreditCardItem(props: ICreditCardItemProps) {
  const {
    creditCard,
    isSelected = false,
    onClick,
    showCheckbox = false,
    alignTop = false,
    moreOptions = false,
  } = props;
  const { t } = useTranslation();

  const handleClick = () => {
    if (onClick) {
      onClick(creditCard);
    }
  };

  return (
    <div
      className={classNames("credit-card-item", {
        "credit-card-item--selected": isSelected,
        "credit-card-item--with-checkbox": showCheckbox,
        "credit-card-item--align-top": alignTop,
      })}
      onClick={handleClick}
    >
      <div className="credit-card-item__content">
        <div>
          <FontAwesomeIcon className="credit-card-item__icon" size="2x" icon={getCreditCardIcon(creditCard?.brand)} />
        </div>

        <div>
          <p className="credit-card-item__information">
            {capitalize(creditCard?.brand)} ending in {creditCard?.last4}
          </p>
          <p className="credit-card-item__expiry">Expiry {creditCard?.expiry}</p>

          {moreOptions && (
            <div className="credit-card-item__more-options">
              <Button
                onClick={e => {
                  e.stopPropagation();
                  console.log("default");
                }}
                type="text"
                className="credit-card-item__more-options__default-button"
                size="small"
              >
                {t("Set as default")}
              </Button>

              <Button
                onClick={e => {
                  e.stopPropagation();
                  console.log("edit");
                }}
                type="text"
                className="credit-card-item__more-options__edit-button"
                size="small"
              >
                {t("Edit")}
              </Button>
            </div>
          )}
        </div>
      </div>

      {showCheckbox && (
        <div className="credit-card-item__checkbox">
          <Checkbox
            size="small"
            value={isSelected}
            checked={isSelected}
            // onChange={}
            labelHidden
            circle
          />
        </div>
      )}
    </div>
  );
}
